export enum Color {
	Gray = 'gray',
	Green = 'green',
	Red = 'red',
	White = 'white',
	HouseGreen = '#B9DCBF',
}
